export default __webpack_public_path__ + "static/media/passedpicture.1dfffcda.png";